module.exports = __webpack_public_path__ + "paid-invoices-icon.png?442100ab840a147a234b586931fc4dde";